var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"carousel-slide",class:[
		{
			animated: _vm.animated,
			active: _vm.isActive,
			transitioning: _vm.isTransitioning,
			previous: _vm.animated && _vm.position < _vm.currentSlide
		},
		_vm.animation
	],attrs:{"role":"group","aria-roledescription":"slide","aria-label":_vm.position + 1 + ' of ' + _vm.totalSlides,"aria-hidden":`${!_vm.isActive}`,"tabindex":_vm.isActive ? 0 : -1},on:{"transitionend":function($event){if($event.target !== $event.currentTarget)return null;return _vm.onTransitionEnd($event)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }